import styled from 'styled-components'

export const DietContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 90vh;
  padding: 0 20%;
  box-sizing: border-box;
  position: relative;

  @media only screen and (max-width: 600px) {
    padding: 0 5%;
  }
`

export const CarouselContainer = styled.div`
  width: 100%;
  top: 52%;
  box-sizing: border-box;
  position: relative;

  @media only screen and (max-width: 600px) {
    top: 35%;
  }
`

export const MealsContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 19px;
  max-height: 50vh;
  overflow: auto;
  box-sizing: border-box;
  padding: 5% 0;

  &.shopping-list {
    width: 50%;

    @media only screen and (max-width: 600px) {
      width: 95%;
      max-height: 66vh;
      /* flex-wrap: wrap; */
    }
  }

  &.no-overflow {
    max-height: unset;
    overflow: unset;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
    box-sizing: border-box;
    height: 25px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: white;
    border-radius: 4px;
    height: 25px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  scrollbar-color: transparent;

  scrollbar-width: 8px;

  @media only screen and (max-width: 600px) {
    width: 95%;
    max-height: 66vh;
    /* flex-wrap: wrap; */
  }
`

export const ChangeDietBox = styled.div`
  display: flex;
  width: fill-available;

  @media only screen and (max-width: 600px) {
    width: 100%;
    justify-content: center;
    /* flex-wrap: wrap; */
  }
`
